module.exports = __webpack_public_path__ + "a2fbf152deb029da1b77aee059abd368.pdf";